import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { FlightCheckAnalysis } from '../../../components/flight-check/FlightCheckAnalysis.js';
import { FlightCheckPage } from '../../../components/flight-check/FlightCheckPage.js';
import { ANALYSIS_MOCK } from '../../../components/flight-check/flightCheckMocks.js';

// Hidden: no nav item links here until the Flight Check backend lands.
function FlightCheckAnalysisRoute(): ReactNode {
  return (
    <FlightCheckPage
      title="Analysis"
      subtitle="Every batch you have run, with its score on each network."
    >
      <FlightCheckAnalysis data={ANALYSIS_MOCK} />
    </FlightCheckPage>
  );
}

export const Route = createFileRoute('/flight-check/analysis/')({
  component: FlightCheckAnalysisRoute,
});
